module.exports = __webpack_public_path__ + "e1.no2.da9b2107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e1.no2.jpg
// module id = ZkqG
// module chunks = 0